import React, { useEffect, useState } from 'react'

export const useConfigGeneral = () => {
    const [mode, setMode] = useState('');

    useEffect(() => {
        const getMode = sessionStorage.getItem('mode');

        if (getMode) {
            setMode(getMode);
        }

    }, []);

    const getDataMode = (mode) => {
        setMode(mode);
        sessionStorage.setItem('mode', mode);
    };

    return {
        mode,
        getDataMode,
    }
}
